"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyMoistureLoadToNewFile = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.copyMoistureLoadToNewFile = (0, graphql_tag_1.default) `
  mutation CopyMoistureLoadToNewFile($moistureLoadId: ID!) {
    copyMoistureLoadToNewFile(moistureLoadId: $moistureLoadId) {
      id
      moistureLoadNo
    }
  }
`;
//# sourceMappingURL=copy-moisture-load-to-new-file.js.map